import { render } from "./Tagline.vue?vue&type=template&id=0011ed86"
import script from "./Tagline.vue?vue&type=script&lang=js"
export * from "./Tagline.vue?vue&type=script&lang=js"

import "./Tagline.vue?vue&type=style&index=0&id=0011ed86&lang=css"

import exportComponent from "/home/zoa/Documents/vue_dev/rachaelmason/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__